import { useCallback, useEffect, useState } from "react"

import { format } from "prettier"
import htmlParser from "prettier/plugins/html"

export default function useHTML({ editing: { value: editing }, engine, craft: { value: craft } }) {
  const [html, setHTML] = useState('')

  const handleCompile = useCallback(async craft => {
    const { html, blocks } = engine.buildHTML(craft)
    const formattedHTML = await formatHTML(html)

    editing.definition.blocks = blocks
    editing.definition.html = formattedHTML
    setHTML(formattedHTML)
  }, [engine, editing])

  useEffect(() => {
    if (craft?.ROOT) {
      handleCompile(craft)
    } else {
      setHTML('')
    }
  }, [craft, handleCompile])

  return html
}

export function formatHTML(html) {
  return format(html, {
    parser: 'html',
    plugins: [htmlParser],
    arrowParens: "always",
    bracketSameLine: true,
    objectWrap: "preserve",
    bracketSpacing: true,
    semi: true,
    experimentalOperatorPosition: "end",
    experimentalTernaries: false,
    singleQuote: false,
    jsxSingleQuote: false,
    quoteProps: "as-needed",
    trailingComma: "all",
    singleAttributePerLine: false,
    htmlWhitespaceSensitivity: "ignore",
    vueIndentScriptAndStyle: false,
    proseWrap: "preserve",
    insertPragma: false,
    printWidth: 100,
    requirePragma: false,
    tabWidth: 2,
    useTabs: false,
    embeddedLanguageFormatting: "auto",
  })
}
